import React from 'react';

/**
 * Hupalupa — marka bazında ürün sayısı (STATİK).
 *
 * Dün   = 30 Tem 2026 Merchant Center yedeği (google_mc_products_preview_raw) — 4.737 ürün.
 * Bugün = 31 Tem 2026 20:45'te mağazanın MC'yi beslediği canlı feed
 *         (hupalupa.store/connectprof/sopiuvmt_hupalupastore) — 3.131 ürün.
 *         Marka feed'in kendi g:brand alanından geliyor (3.131/3.131 dolu).
 *
 * Feed yalnızca stokta olanı yayınlıyor; MC yedeği stoğu bitenleri hâlâ taşıyor.
 * Aradaki fark ürünün silinmesi değil, stoğun tükenmesidir.
 */

// [marka, dün, bugün]
const DATA = [
  ["Ladybird",254,156],
  ["Nosy Crow",144,91],
  ["Funko",134,125],
  ["HUPALUPA",133,133],
  ["Usborne",127,22],
  ["Legami",114,113],
  ["Our Generation",112,91],
  ["LEGO",90,74],
  ["Eeboo",72,0],
  ["Driven",67,56],
  ["Trudi",63,70],
  ["Metalmorphose",61,6],
  ["Sylvanian Families",59,63],
  ["Ooly",57,43],
  ["Martinelia",55,40],
  ["Mini GT",54,40],
  ["Barbie",50,16],
  ["Classic World",49,47],
  ["Mammacomica Dough",49,45],
  ["Playmobil",46,46],
  ["Kipling",46,43],
  ["Mideer",44,43],
  ["B Toys",44,41],
  ["Magna Tiles",42,40],
  ["Globber",42,39],
  ["Micro Scooter",42,39],
  ["Tarmac Work",42,13],
  ["Tubbz",41,33],
  ["Belmil",40,39],
  ["Top Model",40,18],
  ["Bruder",39,3],
  ["Ty",37,45],
  ["Charm It",37,2],
  ["Silverlit",36,20],
  ["Schleich",35,48],
  ["Modu",34,31],
  ["Janod",34,29],
  ["Serve",34,2],
  ["AirPet",33,33],
  ["Quut",33,26],
  ["Clementoni",32,2],
  ["That's My Fun",31,28],
  ["Melissa&Doug",30,32],
  ["Sassi Junior",30,1],
  ["Lego",29,1],
  ["Bblüv",28,39],
  ["Carioca",28,18],
  ["Kikkerland",28,14],
  ["inuwet",28,11],
  ["Intex",27,23],
  ["Igloo",27,19],
  ["Dickie",27,15],
  ["Antonio Juan",26,25],
  ["Meli",26,24],
  ["Panini",26,16],
  ["Auzo Toys",25,17],
  ["Orca",24,24],
  ["Girabrilla",24,17],
  ["Affenzahn",23,23],
  ["Connetix",23,23],
  ["Dock & Bay",23,19],
  ["Spinmaster",23,18],
  ["Make Believe Ideas",23,6],
  ["Vilac",23,4],
  ["Apli",23,1],
  ["Hot Wheels",22,6],
  ["Squishmallows",22,2],
  ["Sipnjoy",21,20],
  ["Taros",21,9],
  ["Floss & Rock",21,5],
  ["Auzou Toys",20,19],
  ["Trixie",20,16],
  ["İnuwet",20,6],
  ["Meri Meri",19,19],
  ["Zuru",19,15],
  ["Bluey",18,18],
  ["Smiggle",18,5],
  ["Lego Kırtasiye",18,2],
  ["Asobu",17,17],
  ["Battat",17,13],
  ["Mini Brands",17,9],
  ["Sunman",17,7],
  ["Duracell",17,6],
  ["Auzou",17,0],
  ["Chocli",17,0],
  ["Dhink",17,0],
  ["Omy",17,0],
  ["Wouf",16,15],
  ["Beyblade",15,15],
  ["Taba",15,15],
  ["Para64",15,1],
  ["Souza",15,1],
  ["Bouncers",15,0],
  ["Bandai",14,18],
  ["Plum",14,14],
  ["Polarbox",14,14],
  ["Rainbocorns",14,14],
  ["Rengarenk Hediyelik",14,14],
  ["Zoo Family",14,13],
  ["Li'l Woodzeez",14,9],
  ["Jarmelo",13,13],
  ["Nici",13,13],
  ["Pi Kids",13,13],
  ["Professor Puzzle",13,13],
  ["MY ARCADE",13,9],
  ["Inno",13,1],
  ["Poppik",13,1],
  ["Aqua Beads",12,12],
  ["Bubble Wand",12,12],
  ["Doppler",12,12],
  ["Otamatone",12,12],
  ["Pokemon",12,0],
  ["K'Nex",11,11],
  ["Selfiko",11,11],
  ["Minix",11,9],
  ["Mıeredu",11,5],
  ["Staedtler",11,4],
  ["Eat My Socks",11,0],
  ["If",11,0],
  ["Imagine That",11,0],
  ["Mustard",11,0],
  ["Very Bella",11,0],
  ["Bopster",10,10],
  ["Volkano",10,9],
  ["Hasbro Gaming",10,4],
  ["ZampaGo",10,1],
  ["Divoom",10,0],
  ["Little Tiger",10,0],
  ["Catlink",9,9],
  ["Cartonic",9,0],
  ["Fatoş",9,0],
  ["Funism",9,0],
  ["Polly Pocket",9,0],
  ["Waytoplay",9,0],
  ["Original Duckhead",8,8],
  ["Robo Alive",8,7],
  ["Waboba",8,6],
  ["Disney100",8,4],
  ["L.O.L",8,3],
  ["Monogram",8,3],
  ["Rastplay",8,2],
  ["Car Tuned",8,0],
  ["Galt",7,9],
  ["Headu",7,7],
  ["Frances Lincoln Children'S",7,6],
  ["Smoby",7,4],
  ["Mattel Games",7,3],
  ["Moulin Roty",7,3],
  ["Sticki Rolls",7,3],
  ["Mole Hobi",7,0],
  ["Yoyo Books",7,0],
  ["Bruno Visconti",6,6],
  ["Greenlight",6,6],
  ["YLZ",6,6],
  ["Yume Toys",6,6],
  ["ABYstyle",6,5],
  ["Adoptme",6,3],
  ["Casdon",6,1],
  ["Jada",6,0],
  ["Mini And Kids",6,0],
  ["SmartGames",6,0],
  ["Upset Duck",6,0],
  ["World's Smallest",6,0],
  ["Santoro",5,6],
  ["Bling2o",5,5],
  ["Gp Gabby",5,5],
  ["Kimmon",5,5],
  ["My Arcade",5,5],
  ["Zoyzoii",5,5],
  ["Başel Toys",5,4],
  ["Smashers",5,3],
  ["Play-Doh",5,2],
  ["Puffin",5,2],
  ["Imaginext",5,1],
  ["Rastar",5,1],
  ["Disney Pixar",5,0],
  ["Fandrop",5,0],
  ["Bavvic",4,4],
  ["Darth Craft",4,4],
  ["Keny Kids",4,4],
  ["Lilamor",4,4],
  ["Lino",4,4],
  ["Playnjoy",4,4],
  ["World Cup",4,4],
  ["MiaMily Carry",4,3],
  ["Rachel Ellen",4,3],
  ["Batman",4,2],
  ["Slimy",4,2],
  ["Beta",4,1],
  ["Maisto",4,1],
  ["B Small Publıshıng French",4,0],
  ["Hasbro Marvel",4,0],
  ["Hobbiez World",4,0],
  ["Mob",4,0],
  ["Moluk",4,0],
  ["Robocar Poli",4,0],
  ["Bestway",3,8],
  ["Matchstick Monkey",3,4],
  ["Cheerble",3,3],
  ["Cicaboom Srl",3,3],
  ["Igofor",3,3],
  ["Neakasa",3,3],
  ["Nerf",3,3],
  ["Penny Scallan",3,3],
  ["Pets Alive",3,3],
  ["Play Circle",3,3],
  ["Samgames",3,3],
  ["Paw Patrol",3,2],
  ["Tossit",3,2],
  ["Amos",3,1],
  ["MARKASIZ",3,1],
  ["Mega",3,1],
  ["Mr. Beast",3,1],
  ["Nintendo",3,1],
  ["Yummiland",3,1],
  ["Disney Frozen",3,0],
  ["McFarlane Toys",3,0],
  ["Papillon",3,0],
  ["Prime 3D",3,0],
  ["Stranger Things",3,0],
  ["Topps",3,0],
  ["Baby Alive",2,2],
  ["Babyhope",2,2],
  ["Dogs vs Squirls",2,2],
  ["Finger Spinnners",2,2],
  ["Gıpta",2,2],
  ["Loop Lasso",2,2],
  ["Mattel Star Wars",2,2],
  ["My Friend Toys",2,2],
  ["Ooshies",2,2],
  ["quarto",2,2],
  ["Shupatto",2,2],
  ["Supergoal",2,2],
  ["X-shot",2,2],
  ["Cicciobello",2,1],
  ["Les Artistes",2,1],
  ["Masha & Koca Ayı",2,1],
  ["Mondo",2,1],
  ["Star Wars",2,1],
  ["Unicus",2,1],
  ["Ctoy",2,0],
  ["Hasbro Star Wars",2,0],
  ["Helpı Kıds Books",2,0],
  ["Monster High",2,0],
  ["Pixel",2,0],
  ["Pop Race",2,0],
  ["Scrikss",2,0],
  ["Takara Tomy",2,0],
  ["TerrorFried",2,0],
  ["Trunki",2,0],
  ["Two Wındmılls",2,0],
  ["Berenguer",1,1],
  ["BIG",1,1],
  ["Big",1,1],
  ["Carrera",1,1],
  ["Carson",1,1],
  ["Cocomelon",1,1],
  ["Enabot",1,1],
  ["Fisher Price",1,1],
  ["Gifi Harry Potter",1,1],
  ["Hexbug",1,1],
  ["Kuaki",1,1],
  ["Majorette",1,1],
  ["Mega Bloks",1,1],
  ["Minecraft",1,1],
  ["Moj Moj",1,1],
  ["Monster Jam",1,1],
  ["My Fuzzie Friends",1,1],
  ["My Little Pony",1,1],
  ["Nebulous Stars",1,1],
  ["Neco Plush",1,1],
  ["Petronix",1,1],
  ["Phlat Ball",1,1],
  ["Poogi",1,1],
  ["Priddy Books",1,1],
  ["Roblox",1,1],
  ["Samatlı İth",1,1],
  ["Smartball",1,1],
  ["Solido",1,1],
  ["Ternx",1,1],
  ["Uniball",1,1],
  ["Vtk",1,1],
  ["ZAPF Creation",1,1],
  ["Aphmau",1,0],
  ["Coco Cones",1,0],
  ["Cookeez Makery",1,0],
  ["Cry Babies",1,0],
  ["Egmont",1,0],
  ["Fluffie",1,0],
  ["Gp Skıbıdı",1,0],
  ["Gp Stitch",1,0],
  ["Gp Şirinler",1,0],
  ["Happy Yappers",1,0],
  ["Hey Clay",1,0],
  ["LEGO Kırtasiye",1,0],
  ["Let's Be Child",1,0],
  ["Lexon",1,0],
  ["Light Plus Nine",1,0],
  ["Metal Machines",1,0],
  ["Mini Kyomo",1,0],
  ["Mrbeast",1,0],
  ["Out Of The Blue",1,0],
  ["Revell",1,0],
  ["Snails",1,0],
  ["Sonic",1,0],
  ["Spidey",1,0],
  ["Sunny Life",1,0],
  ["Tung Tung",1,0],
  ["Wide Eyed Editions",1,0],
  ["Ylvi",1,0],
  ["LEGO Fırsat Ürünü",0,16],
  ["Packnjoy",0,12],];

const fmt = (n) => Number(n).toLocaleString('tr-TR');
const DUN = DATA.reduce((a, r) => a + r[1], 0);
const BUGUN = DATA.reduce((a, r) => a + r[2], 0);
const SIFIRLANAN = DATA.filter((r) => r[1] > 0 && r[2] === 0).length;

export default function HupalupaBrandStock() {
  return (
    <div className="p-6 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-900">Marka Bazında Ürün Sayısı</h1>
      <p className="text-gray-600 mt-1">
        Dün 30 Temmuz 2026 Merchant Center yedeği · Bugün 31 Temmuz 2026 canlı ürün feed'i
      </p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 my-6">
        {[
          ['Dün · 30 Tem', fmt(DUN), 'text-gray-900'],
          ['Bugün · 31 Tem', fmt(BUGUN), 'text-gray-900'],
          ['Fark', fmt(BUGUN - DUN) + ` (%${(((BUGUN - DUN) / DUN) * 100).toFixed(1)})`, 'text-rose-600'],
          ['Sıfırlanan marka', fmt(SIFIRLANAN), 'text-gray-900'],
        ].map(([baslik, deger, renk]) => (
          <div key={baslik} className="bg-white rounded-xl border border-gray-200 p-4">
            <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">{baslik}</div>
            <div className={`text-2xl font-bold mt-1 tabular-nums ${renk}`}>{deger}</div>
          </div>
        ))}
      </div>

      <p className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-900 mb-6">
        <strong>Ürünler silinmedi, stokları bitti.</strong> Feed yalnızca stokta olan ürünü yayınlıyor
        (3.131'inin tamamı <code className="bg-amber-100 px-1 rounded">in stock</code>); Merchant Center yedeği
        stoğu bitenleri hâlâ taşıdığı için {fmt(DUN - BUGUN)} ürünlük fark oluşuyor.
      </p>

      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="text-left font-medium px-4 py-2.5">Marka</th>
              <th className="text-right font-medium px-4 py-2.5">Dün</th>
              <th className="text-right font-medium px-4 py-2.5">Bugün</th>
              <th className="text-right font-medium px-4 py-2.5">Fark</th>
            </tr>
          </thead>
          <tbody>
            {DATA.map(([marka, dun, bugun]) => (
              <tr key={marka} className="border-t border-gray-100">
                <td className="px-4 py-2 text-gray-900">{marka}</td>
                <td className="px-4 py-2 text-right tabular-nums text-gray-600">{fmt(dun)}</td>
                <td className="px-4 py-2 text-right tabular-nums text-gray-900 font-medium">{fmt(bugun)}</td>
                <td
                  className={`px-4 py-2 text-right tabular-nums ${
                    bugun - dun < 0 ? 'text-rose-600' : bugun - dun > 0 ? 'text-emerald-600' : 'text-gray-400'
                  }`}
                >
                  {bugun - dun > 0 ? '+' : ''}
                  {fmt(bugun - dun)}
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="bg-gray-50 font-semibold text-gray-900">
            <tr className="border-t border-gray-200">
              <td className="px-4 py-2.5">Toplam · {fmt(DATA.length)} marka</td>
              <td className="px-4 py-2.5 text-right tabular-nums">{fmt(DUN)}</td>
              <td className="px-4 py-2.5 text-right tabular-nums">{fmt(BUGUN)}</td>
              <td className="px-4 py-2.5 text-right tabular-nums text-rose-600">{fmt(BUGUN - DUN)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      <p className="mt-3 text-xs text-gray-500">Statik sayfa — veri 31 Temmuz 2026 20:45'te dondurulmuştur.</p>
    </div>
  );
}
